module.exports = __webpack_public_path__ + "static/img/tantanrouPic.7cbb0225.png";